/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import {
  MigrationStepName,
  PromotionStepName,
} from 'app/developer-v3/components/SidebarRight/types';

import CountItem from './CountItem';

const Styles = {
  hrSpacer: css`
    margin-top: 10px;
    margin-bottom: 10px;
  `,
};

type Props = {
  finished: number;
  total: number;
  type: string;
};

const labelTitleMap = {
  [MigrationStepName.migrateZaps]: 'Zaps',
  [MigrationStepName.addCustomusers]: 'Users',
  [PromotionStepName.migrateZts]: 'Zap templates',
  [PromotionStepName.rebuildAllowlist]: 'Users',
};

const CountList = ({ finished, total, type }: Props) => {
  const labelTitle = labelTitleMap[type] || 'Items';

  return (
    <ul>
      <CountItem label={`${labelTitle} Updated`} value={finished} />
      <CountItem label={`${labelTitle} Remaining`} value={total - finished} />
      <hr css={Styles.hrSpacer} />
      <CountItem label={`Total ${labelTitle}`} value={total} />
    </ul>
  );
};

export default CountList;
